// vuex namespace
export const SHIPMENT = 'shipment';

// store props
export const CONTENT = 'content';
export const DETAILS = 'details';
export const DOCUMENTS = 'documents';
export const EVENTS = 'events';
export const ID_SEARCH = 'idSearch';
export const SCOPEFLOWS_SEARCH = 'scopeflowsSearch';
export const DIMENSIONS_SEARCH = 'dimensionsSearch';

// store mutations
export const SET_CONTENT = 'setContent';
export const SET_DETAILS = 'setDetails';
export const SET_DOCUMENTS = 'setDocuments';
export const SET_EVENTS = 'setEvents';
export const SET_ID_SEARCH = 'setIdSearch';
export const SET_SCOPEFLOWS_SEARCH = 'setScopeflowsSearch';
export const SET_DIMENSIONS_SEARCH = 'setDimensionsSearch';
export const SET_CURRENT_SCOPEFLOW = 'setCurrentScopeflow';
export const RESET_SHIPMENT_RESULTS = 'resetShipmentResults';
export const SET_DETAILS_REFERENCES = 'setDetailsReferences';


// store getters
export const GET_DOCUMENTS = 'getDocuments';
export const GET_DOCUMENT_CATEGORIES = 'getDocumentCategories';
export const GET_ID_SEARCH = 'getIdSearch';
export const GET_SCOPEFLOWS_SEARCH = 'getScopeflowsSearch';
export const GET_DIMENSIONS_SEARCH = 'getDimensionsSearch';
export const GET_DETAILS_REFERENCES = 'getDetailsReferences';
